import { createStore, withProps } from '@ngneat/elf';
import { SelectOption } from '../../../components/form-builder/form-builder.types';
import { DynamicFieldDto, DynaStatus } from '@/types';

export interface DynamicFieldProps {
  dto: DynamicFieldDto;
  typeSelected: SelectOption;
  errors: Record<string, any>;
}

export const dynamicFieldInitialState: DynamicFieldProps = {
  dto: {
    dynaFormFieldsId: null,
    status: DynaStatus.NON_ACTIF,
    name: '',
    label: '',
    description: '',
    type: undefined,
    isRequired: false,
    order: undefined,
    hasTotal: false,
    isFormula: false,
    formula: '',
  },
  typeSelected: { name: '', code: undefined },
  errors: {},
};

export const dynamicFieldStoreFactory = (id: string) => {
  return createStore({ name: `dynamic-field-state-${id}` }, withProps<DynamicFieldProps>(structuredClone(dynamicFieldInitialState)));
};
